import { useEffect, useState } from 'react';
import { IOrderDetailsTabList } from 'types/orders';

import './Tabs.scss';

interface ITabs {
  selectedTabId?: number;
  defaultSelectedTabId?: number;
  tabs: Partial<IOrderDetailsTabList>[];
  loading?: boolean;
  onSelectTab: (newTabId: number) => void;
}

export const Tabs = ({ tabs, selectedTabId, defaultSelectedTabId, loading, onSelectTab }: ITabs) => {
  const [tabId, setTabId] = useState<number | undefined>(defaultSelectedTabId);

  const updateTabId = (tabId?: number) => {
    if (tabId) {
      setTabId(tabId);
    }
  };

  useEffect(() => {
    updateTabId(selectedTabId);
  }, [selectedTabId]);

  return (
    <div className="tabsRoot">
      <div className="tabs">
        {tabs.map(({ tabName, tabId: TAB_ID, hidden }, idx) => {
          const id = TAB_ID ?? idx;

          if (hidden) return null;

          return (
            <button
              key={idx}
              disabled={loading}
              onClick={() => {
                setTabId(id);
                onSelectTab(id);
              }}
              className={`tab ${loading ? `fullSkeleton loading` : ''} ${id === tabId ? 'selected' : ''}`}
            >
              <span className="tabItem">{tabName}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
